import { useStaticQuery, graphql } from 'gatsby'

const useLatestPosts = () => {
  const data = useStaticQuery(graphql`
    {
      allWpPost(limit: 20) {
        nodes {
          title
          slug
          excerpt
          date
          featuredImage {
            node {
              ...LocalImageFrag
            }
          }
        }
      }
    }
  `)
  return data.allWpPost.nodes
}

export default useLatestPosts
